import React, { useState, useEffect } from "react";
import { API_BASE } from "../apiBase";

export default function DynamicKeepaGraphPopup(props) {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  const changeRange = (e) => {
    props.setRange(e.target.value);
    localStorage.setItem("DKGrange", e.target.value);
  };

  const fixRange = (e) => {
    if (e.target.value < 1) {
      props.setRange(30);
      localStorage.setItem("DKGrange", 30);
    }
  };

  const getImageSource = async () => {
    const params = new URLSearchParams({
      domain: 1,
      salesrank: props.bsr_state ? 1 : 0,
      amazon: props.az_state ? 1 : 0,
      new: props.new_state ? 1 : 0,
      bb: props.bb_state ? 1 : 0,
      fba: props.fba_state ? 1 : 0,
      range: props.range_state ?? 90
    });

    const response = await fetch(
      `${API_BASE}/get_keepa_image/${props.asin}/?${params}`,
      { mode: "cors" }
    );
    const data = await response.json();
    return data.url;
  };

  // Update image whenever any state changes
  useEffect(() => {
    if (props.asin) {
      setLoading(true);
      getImageSource().then(url => {
        setImageUrl(url);
        setLoading(false);
      }).catch(err => {
        console.error("Failed to load image:", err);
        setLoading(false);
      });
    }
  }, [props.asin, props.range_state, props.bsr_state, props.az_state, props.new_state, props.bb_state, props.fba_state]);

  return (
    <div
      id="modal-js-example"
      className={
        "modal" + (props.asin !== null ? " is-active" : "")
      }
      style={{ zIndex: "9999999999" }}
    >
      <div className="modal-background" onClick={() => { props.setDKGAsin(null) }}></div>

      <div
        className="modal-content"
        style={{ width: props.isMobile ? "90vw" : "55vw", fontSize: ".95vw" }}
      >
        <div className="box" style={{ textAlign: "center" }}>
          <p style={{ fontSize: props.isMobile ? "2.5vh" : "1.1vw" }}>
            <strong>Dynamic Keepa Graph</strong>
          </p>
          <br />
          <div className="container">
            <div className="columns">
              {" "}
              {/* First raw */}
              <div className="column is-flex is-2 is-align-items-center" style={{ marginLeft: "31.5%" }}>
                <button
                  onClick={() => changeRange({ target: { value: 30 } })}
                  className="button is-rounded selectlight"
                  style={{ width: "3vw", height: "2vw", fontSize: "1.1vw" }}
                >
                  30
                </button>&emsp;
                <button
                  onClick={() => changeRange({ target: { value: 60 } })}
                  className="button is-rounded selectlight"
                  style={{ width: "3vw", height: "2vw", fontSize: "1.1vw" }}
                >
                  60
                </button>&emsp;
                <button
                  onClick={() => changeRange({ target: { value: 90 } })}
                  className="button is-rounded selectlight"
                  style={{ width: "3vw", height: "2vw", fontSize: "1.1vw" }}
                >
                  90
                </button>&emsp;
                <button
                  onClick={() => changeRange({ target: { value: 180 } })}
                  className="button is-rounded selectlight"
                  style={{ width: "3vw", height: "2vw", fontSize: "1.1vw" }}
                >
                  180
                </button>&emsp;
                <button
                  onClick={() => changeRange({ target: { value: 365 } })}
                  className="button is-rounded selectlight"
                  style={{ width: "3vw", height: "2vw", fontSize: "1.1vw" }}
                >
                  365
                </button>
              </div>
            </div>
            <div className="columns">
              {" "}
              {/* Second raw */}
              <div className="column is-3 is-flex is-flex-direction-column">
                {" "}
                {/* 3 buttons */}
                <label className="checkbox is-flex is-flex-direction-row is-align-items-center is-justify-content-flex-end">
                  Sales Rank{"\u00A0"}
                  <input
                    type="checkbox"
                    className="round-checkbox"
                    checked={props.bsr_state}
                    onClick={(e) => {
                      props.setBsr(!props.bsr_state);
                      localStorage.setItem("DKGbsr", e.target.checked);
                    }}
                  ></input>
                </label>
                <label className="checkbox is-flex is-flex-direction-row is-align-items-center is-justify-content-flex-end">
                  Amazon{"\u00A0"}
                  <input
                    type="checkbox"
                    className="round-checkbox"
                    checked={props.az_state}
                    onClick={(e) => {
                      props.setAz(!props.az_state);
                      localStorage.setItem("DKGaz", e.target.checked);
                    }}
                  ></input>
                </label>
                <label className="checkbox is-flex is-flex-direction-row is-align-items-center is-justify-content-flex-end">
                  New{"\u00A0"}
                  <input
                    type="checkbox"
                    className="round-checkbox"
                    checked={props.new_state}
                    onClick={(e) => {
                      props.setNew(!props.new_state);
                      localStorage.setItem("DKGnew", e.target.checked);
                    }}
                  ></input>
                </label>
              </div>
              <div className="column is-6">
                {" "}
                {/* img */}
                {loading ? (
                  <div style={{ height: "200px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid gray" }}>
                    Loading...
                  </div>
                ) : (
                  <img
                    loading="lazy"
                    onClick={() => window.open(imageUrl, "_blank")}
                    src={imageUrl}
                    alt="keepahist"
                    style={{ position: "relative", border: "1px solid gray", height: "100%" }}
                    className="disableHoverCssDynamicKeepa"
                  />
                )}
              </div>
              <div className="column is-3 is-flex is-flex-direction-column">
                {" "}
                {/* 2 buttons */}
                <label className="checkbox is-flex is-flex-direction-row is-align-items-center">
                  <input
                    type="checkbox"
                    className="round-checkbox"
                    checked={props.bb_state}
                    onClick={(e) => {
                      props.setBb(!props.bb_state);
                      localStorage.setItem("DKGbb", e.target.checked);
                    }}
                  ></input>
                  {"\u00A0"}Buy Box
                </label>
                <label className="checkbox is-flex is-flex-direction-row is-align-items-center">
                  <input
                    type="checkbox"
                    className="round-checkbox"
                    checked={props.fba_state}
                    onClick={(e) => {
                      props.setFba(!props.fba_state);
                      localStorage.setItem("DKGfba", e.target.checked);
                    }}
                  ></input>
                  {"\u00A0"}New FBA
                </label>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="columns is-mobile is-centered">
            <button
              className="button is-rounded is-danger"
              style={{ fontSize: props.isMobile ? "1.9vh" : ".95vw" }}
              onClick={() => {
                props.setDKGAsin(null);
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}